import type * as React from "react";
import DeletableChip from "~/components/Chips/DeletableChip";
import { DeprecatedMultiSelect } from "~/components/MultiSelect/MultiSelect";
import type { FormFieldProps } from "~/components/form";
import type { ComponentProps } from "~/utils/types";
interface TagSetTypeMultiSelectProps extends FormFieldProps<string[]> {
    items: {
        Id: string;
        Name: string;
    }[];
    autoFocus?: boolean;
    label?: string | JSX.Element;
    error?: string;
    accessibleName?: string;
    renderChip?: (item: {
        Id: string;
        Name: string;
    }, onRequestDelete: () => void) => JSX.Element;
}
const TagSetTypeTypedMultiSelect = DeprecatedMultiSelect<{
    Id: string;
    Name: string;
}>();
type RenderChip = ComponentProps<typeof TagSetTypeTypedMultiSelect>["renderChip"];
export const TagSetTypeMultiSelect: React.FC<TagSetTypeMultiSelectProps> = (props) => {
    const defaultChipRenderer: RenderChip = (item, onRequestDelete: () => void) => {
        return (<DeletableChip description={`${item.Id}: ${item.Name}`} key={item.Id} onRequestDelete={onRequestDelete} deleteButtonAccessibleName={`Remove ${item.Name}`}>
                {item.Name}
            </DeletableChip>);
    };
    const chipRenderer = props.renderChip || defaultChipRenderer;
    return <TagSetTypeTypedMultiSelect fieldName="tag set types" renderChip={chipRenderer} accessibleName={props.accessibleName} {...props} items={props.items}/>;
};
TagSetTypeMultiSelect.displayName = "TagSetTypeMultiSelect"
export const SupportedTagSetTypes = ["SingleSelect", "MultiSelect", "FreeText"];
